import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs";
import {DeploymentService} from "../../deployment/deployment.service";
import {handleErrors} from "../../misc/handle-errors.decorator";

export interface RejectDeploymentDialogModel {
  deploymentId: string;
  workflowId: string;
}

@Component({
  templateUrl: "./reject-deployment-dialog.template.pug",
  providers: [
    DeploymentService,
  ],
})
export class RejectDeploymentDialogComponent
  extends DialogComponent<RejectDeploymentDialogModel, any> implements RejectDeploymentDialogModel {
  public deploymentId: string;
  public workflowId: string;
  public error: Error;
  public rejectReasons: string;

  static showRejectDeploymentDialogModal(dialogService: DialogService, inputs: RejectDeploymentDialogModel):
  Observable<any> {
    return dialogService.addDialog(RejectDeploymentDialogComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  cancel(): void {
    this.result = {success: false};
    this.close();
  }

  @handleErrors()
  async reject(): Promise<void> {
    await this.deploymentService.rejectDeployment(this.deploymentId, this.rejectReasons);

    this.result = {success: true, message: "Deployment rejected."};
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    private deploymentService: DeploymentService,
  ) {
    super(dialogService);
  }
}
